import { useEffect, useState } from 'react';
import {
  Box, Typography, Paper, Chip, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress, Button,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ChatIcon from '@mui/icons-material/Chat';
import { api } from '../../api/api';

export default function ChatSettings() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/chat/rooms/all');
      setRooms(data.rooms);
    } catch (_) {} finally { setLoading(false); }
  };

  useEffect(() => { fetchRooms(); }, []);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <ChatIcon sx={{ color: '#551FFF', fontSize: 20 }} />
        <Typography sx={{ fontWeight: 700, fontSize: 16 }}>Chat Rooms</Typography>
        <Button size="small" startIcon={<RefreshIcon />} onClick={fetchRooms} sx={{ ml: 'auto' }}>
          새로고침
        </Button>
      </Box>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, mb: 3 }}>
        <Typography sx={{ fontSize: 13, color: '#888', mb: 1 }}>
          Socket.IO 기반 실시간 채팅입니다. 우측 하단 채팅 아이콘으로 대화할 수 있습니다.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label="실시간 메시지" size="small" variant="outlined" />
          <Chip label="읽음 표시" size="small" variant="outlined" />
          <Chip label="입력 중 표시" size="small" variant="outlined" />
          <Chip label="읽지 않은 메시지 배지" size="small" variant="outlined" />
        </Box>
      </Paper>

      {loading ? (
        <Box sx={{ textAlign: 'center', py: 3 }}><CircularProgress size={28} /></Box>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ '& th': { fontWeight: 700, fontSize: 12, color: '#888' } }}>
                <TableCell>Room ID</TableCell>
                <TableCell>Store</TableCell>
                <TableCell>참여자</TableCell>
                <TableCell>마지막 메시지</TableCell>
                <TableCell>날짜</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rooms.map((r) => (
                <TableRow key={r.roomId} hover>
                  <TableCell sx={{ fontSize: 12, fontFamily: 'monospace' }}>{r.roomId}</TableCell>
                  <TableCell sx={{ fontSize: 13 }}>{r.storeName || '-'}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      {(r.participants || []).map((p, i) => (
                        <Chip key={i} label={`${p.name} (${p.role})`} size="small"
                          variant="outlined" sx={{ fontSize: 10, height: 20 }} />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontSize: 12, color: '#555', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {r.lastMessage || '-'}
                  </TableCell>
                  <TableCell sx={{ fontSize: 11, color: '#888' }}>
                    {r.lastMessageAt ? new Date(r.lastMessageAt).toLocaleString('ko-KR') : '-'}
                  </TableCell>
                </TableRow>
              ))}
              {rooms.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3, color: '#888' }}>
                    생성된 채팅방이 없습니다.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
